module.exports = __webpack_public_path__ + "media/application/images/external-services/wix-logo-9ef4fa3f256df3483391a65179422b7c.svg";